import axios from "axios";
import { API_URL } from "../../services/api";

function createFormData(formData, data, key) {
    if ((typeof data === "object" && data !== null) || Array.isArray(data)) {
        for (let i in data) {
            if (
                (typeof data[i] === "object" && data[i] !== null) ||
                Array.isArray(data[i])
            ) {
                createFormData(formData, data[i], key + "[" + i + "]");
            } else {
                formData.append(key + "[" + i + "]", data[i]);
            }
        }
    } else {
        formData.append(key, data);
    }
}

const headers = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token.token}`,
        },
    };
};

// afregar envio de imagen
export const save = (
    formConfig,
    dataInput,
    autorespuesta,
    retargeting,
    resetForm,
    token
) => {
    const data = new FormData();
    createFormData(data, formConfig, "formConfig");
    createFormData(data, dataInput, "dataInput");
    data.append("autorespuesta", autorespuesta);
    data.append("retargeting", retargeting);

    return axios
        .post(
            API_URL + "form",
            data,
            headers({
                ...token,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
        )
        .then((response) => {
            resetForm();
            return {
                success: true,
                message: "Guardado",
            };
        })
        .catch((error) => {
            return {
                success: false,
                message: "Error al guardar",
            };
        });
};

export const save_input = (slug, input, token) => {
    const data = {
        data: input,
        slug,
    };

    return axios
        .post(API_URL + "form-input", data, headers(token))
        .then((response) => {
            return {
                success: true,
                message: response.data.message,
            };
        })
        .catch((error) => {
            return {
                success: false,
                message: "No editado",
            };
        });
};

// afregar envio de imagen
export const edit_config = (config, form, mails, token) => {
    const data = new FormData();

    createFormData(data, "put", "_method");
    createFormData(data, mails, "send_to");
    for (const key in config) {
        if (Object.hasOwnProperty.call(config, key)) {
            const value = config[key];
            const images = ["autorespuesta", "retargeting"];
            if (images.includes(key) && value.length) {
                if (typeof value[0] == "object") {
                    data.append(key, value[0]);
                }
            } else {
                if (value) {
                    data.append(key, value);
                }
            }
        }
    }

    return axios
        .post(
            API_URL + "form/" + form.id,
            data,
            headers({
                ...token,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
        )
        .then((response) => {
            return {
                success: true,
                message: response.data.message,
            };
        })
        .catch((error) => {
            return {
                success: false,
                message: "No editado",
            };
        });
};

export const edit_input = (editInput, dataSelectArray, token) => {
    const data = {
        data: editInput,
        data_select: dataSelectArray,
        _method: "put",
    };

    return axios
        .post(API_URL + "form-input/" + editInput.id, data, headers(token))
        .then((response) => {
            return {
                success: true,
                message: response.data.message,
            };
        })
        .catch((error) => {
            return {
                success: false,
                message: "No editado",
            };
        });
};
export default save;
